<template>
  <div class="client-container">
    <el-row class="tcf-row">
      <el-col :span="24" class="card">
        <div class="card-body">
          <div class="card-title">
            客户主页
          </div>
          <div class="card-content" v-loading="loading" v-if="clientinfo.client_id!=null">
            <el-row>
              <el-col :span="5">
                <el-row>
                  <el-col :span="16" class="client-info-row">
                    <span class="client-name">{{clientinfo.client_name}}</span>
                    <svg-icon icon-class="client_man" class="client-sex" v-if="clientinfo.sex === 1" />
                    <svg-icon icon-class="client_women" class="client-sex" v-if="clientinfo.sex === 0" />
                  </el-col>
                  <!--<el-col :span="8" style="text-align: right">
                    <el-button type="text" v-if="clientinfo.mark==2" size="small" icon="el-icon-edit" @click="editInfo">客户编辑</el-button>
                  </el-col>-->
                  <el-col :span="24" class="client-info-row row-line">
                    <el-tag type="danger" size="mini" v-if="clientinfo.is_over==1 && clientinfo.mark<3">即将回收</el-tag>
                    <el-tag size="mini" v-if="clientinfo.mark>=3">已签约</el-tag>
                    <el-tag v-for="(tag,index) in clientinfo.tagList" :type="index==0?'success':index==1?'warning':''" v-if="clientinfo.mark<3" size="mini" style="margin-right: 4px">{{tag.name}}</el-tag>
                  </el-col>
                  <el-col :span="24" class="client-info-row">
                    <i class="el-icon-phone"></i> {{clientinfo.tel}}
                  </el-col>
                  <el-col :span="24" class="client-info-row">
                    <svg-icon icon-class="wechat" style="color:#606266;width: 13px;" /> {{clientinfo.weixin}}
                  </el-col>
                  <el-col :span="24" class="client-info-row row-line">
                    <i class="el-icon-location"></i> {{clientinfo.province}} {{clientinfo.city}} {{clientinfo.county}}
                  </el-col>
                  <el-col v-if="clientinfo.shop!==null&&clientinfo.shop!==''" :span="24" class="client-info-row">
                    <i class="el-icon-s-shop"></i> {{clientinfo.shop}}
                  </el-col>
                  <el-col v-if="clientinfo.area!==null&&clientinfo.area!==0" :span="24" class="client-info-row row-line">
                    <i class="el-icon-crop"></i> {{clientinfo.area}}m²
                  </el-col>
                  <el-col :span="24" class="client-info-row">
                    已有<span style="font-size: 14px;font-weight: 500;color:#409EFF;margin:0 6px">{{clientinfo.followed}}</span>人跟进
                  </el-col>
                  <el-col :span="24" class="client-info-row row-line">
                    已有<span style="font-size: 14px;font-weight: 500;color:#409EFF;margin:0 6px">{{clientinfo.follownum}}</span>次跟进
                  </el-col>
                  <el-col :span="24" class="client-info-row" style="color:#999;font-size:12px;">
                    备注：{{clientinfo.remark}}
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="19">
                <el-timeline>
                  <!--<el-timeline-item v-if="clientinfo.mark===2" timestamp="" placement="top">
                    <el-button size="small" type="primary" @click="addVisible = true">添加跟进</el-button>
                    <el-button size="small" @click="openHtqd">合同签订</el-button>
                    <el-button size="small" @click="intoHighSeas" type="danger" plain>放入公海</el-button>
                  </el-timeline-item>-->
                  <el-timeline-item v-if="clientinfo.mark===1" timestamp="" placement="top">
                    <el-button size="medium" type="primary" @click="followClient">我来跟进此客户</el-button>
                  </el-timeline-item>
                  <el-timeline-item v-for="ritem in clientinfo.recordList" :timestamp="ritem.time" placement="top">
                    <el-card>
                      <el-button v-if="ritem.user_id===user.dUserid&&ritem.type===1&&clientinfo.mark===2" @click="editRecord(ritem.record_id)" class="follow-editbtn" type="text" size="small" icon="el-icon-edit">编辑</el-button>
                      <h4 class="follow-txt"><el-tag v-if="ritem.follow_name!=null&&ritem.follow_name!=''" size="mini" effect="plain">{{ritem.follow_name}}</el-tag>&nbsp;&nbsp;{{ritem.way}}</h4>
                      <p class="follow-content"> {{ritem.content}}</p>
                    </el-card>
                  </el-timeline-item>
                  <el-timeline-item :timestamp="clientinfo.create_time" placement="top">
                    <el-card>
                      <h4 class="follow-txt">客户录入</h4>
                      <p class="follow-content">{{clientinfo.dept_name}}-{{clientinfo.create_name}}&nbsp;<span style="color:#409EFF">提供</span></p>
                    </el-card>
                  </el-timeline-item>
                </el-timeline>

              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="编辑客户信息"
      :visible.sync="editInfoVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="eForm" :model="eForm" :rules="eRules"  label-position="right" label-width="75px" size="small">
        <el-form-item label="姓名" prop="realname">
          <el-input v-model="eForm.realname" maxlength="5"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="tel">
          <el-input v-model="eForm.tel" maxlength="11" minlength="11"></el-input>
        </el-form-item>
        <el-form-item label="微信" prop="weixin">
          <el-input v-model="eForm.weixin" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="eForm.sex">
            <el-radio label="2">未知</el-radio>
            <el-radio label="1">男</el-radio>
            <el-radio label="0">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="地区" prop="city">
          <el-cascader
            style="width:100%"
            v-model="eForm.city"
            :options="cityoptions"
            filterable></el-cascader>
        </el-form-item>
        <el-form-item label="线下门店">
          <el-input v-model="eForm.shop" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="门店面积" prop="area" style="width: 400px;">
          <el-input v-model="eForm.area">
            <template slot="append">m²</template>
          </el-input>
        </el-form-item>
        <el-form-item label="分组" prop="groupid">
          <el-select v-model="eForm.groupid" filterable :clearable="true">
            <el-option
              v-for="gitem in groupoptions"
              :key="gitem.value"
              :label="gitem.label"
              :value="gitem.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标签" prop="labels">
          <el-checkbox-group v-model="eForm.labels" :max="3">
            <el-checkbox v-for="titem in tagaoption" :label="titem.tagid" name="labels">{{titem.name}}</el-checkbox>
          </el-checkbox-group>
          <el-button size="small" icon="el-icon-edit" type="text" @click="tagsDrawer = true">标签管理...</el-button>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="eForm.remark" maxlength="200"></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editloading" @click="subEditInfo('eForm')">立即提交</el-button>
          <el-button @click="editInfoVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="添加跟进记录"
      :visible.sync="addVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="addForm" :model="addForm" :rules="rulesAdd"  label-position="right" label-width="75px" size="small">
        <el-form-item label="方式" prop="way" >
          <el-select v-model="addForm.way">
            <el-option
              v-for="witem in wayOption"
              :key="witem.ftid"
              :label="witem.name"
              :value="witem.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标签" prop="labels">
          <el-checkbox-group v-model="addForm.labels" :max="3">
            <el-checkbox v-for="titem in tagaoption" :label="titem.tagid" name="labels">{{titem.name}}</el-checkbox>
          </el-checkbox-group>
          <el-button size="small" icon="el-icon-edit" type="text" @click="tagsDrawer = true">标签管理...</el-button>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="addForm.remark" maxlength="300"></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="addLoading" :disabled="addDisabled" @click="submitAddForm('addForm')">{{addBtnName}}</el-button>
          <el-button @click="closeAddForm('addForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-drawer
      title="标签管理"
      :visible.sync="tagsDrawer"
      direction="rtl">
      <div class="tags-container">
        <el-row>
          <div v-for="t in tagaoption" class="tags-item">
            <span>{{t.name}}</span>
            <el-button v-if="t.userid != 0" type="danger" @click="delTags(t.tagid)" class="tags-del" icon="el-icon-close" circle></el-button>
          </div>
          <el-button @click="addTags" size="small" icon="el-icon-plus" type="primary" plain>添加</el-button>
        </el-row>
      </div>
    </el-drawer>
    <el-dialog
      title="编辑跟进记录"
      :visible.sync="editRecordVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="recordForm" :model="recordForm" :rules="rulesRecord"  label-position="right" label-width="75px" size="small">
        <el-form-item label="方式" prop="way" >
          <el-select v-model="recordForm.way">
            <el-option
              v-for="witem in wayOption"
              :key="witem.ftid"
              :label="witem.name"
              :value="witem.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="recordForm.remark" maxlength="300"></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="addLoading" :disabled="addDisabled" @click="subEditRecord('recordForm')">立即提交</el-button>
          <el-button @click="editRecordVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="合同签订"
      :visible.sync="htqdVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="htqdForm" :model="htqdForm" :rules="htqdRules"  label-position="right" label-width="75px" size="small">
        <el-form-item label="签订客户" prop="clientname">
          <el-input
            v-model="htqdForm.clientname"
            :disabled="true">
          </el-input>
        </el-form-item>
        <el-form-item label="签订日期" prop="time">
          <el-date-picker
            v-model="htqdForm.time"
            type="date"
            style="width:240px"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="签订地点" prop="address">
          <el-input v-model="htqdForm.address" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="签订合同" prop="contractid">
          <el-select v-model="htqdForm.contractid" style="width:350px" placeholder="请选择" clearable filterable>
            <el-option
              v-for="item in contractList"
              :key="item.content_id"
              :label="item.name+'（'+item.code+'）'"
              :value="item.content_id">
              <span style="float: left">{{ item.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.code }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户全称" prop="allname">
          <el-input v-model="htqdForm.allname" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="代理品牌" prop="brand">
          <el-select v-model="htqdForm.brand" style="width:100%" multiple placeholder="请选择">
            <el-option
              v-for="item in brandList"
              :key="item.brand_id"
              :label="item.brand_name"
              :value="item.brand_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="展厅负责" prop="groupId">
          <el-select v-model="htqdForm.groupId" placeholder="请选择">
            <el-option
              v-for="item in groupList"
              :key="item.dGroupid"
              :label="item.dAbbname"
              :value="item.dGroupid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同原件" prop="imgids">
          <MultiImg :limit="9" :size="'sm'" ref="img" v-model="htqdForm.imgids" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="htqdForm.remark" maxlength="300"></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editloading" @click="subHtqd('htqdForm')">立即提交</el-button>
          <el-button @click="htqdVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { validatePhoneNumber } from '@/utils/validate'
import { getUser } from '@/utils/auth'
import { getClientDetail2, getClientLabel, editClientLabel, editFollowRecord, getWayAndLabels, getClientGroupList, addClient, intoHighSeas, followPublicClient, signContract, getContractList, getBrandList, getGroup } from '@/api/work'
import { getCity } from '@/utils/city'
import MultiImg from '@/components/upload/MultiImg'

export default {
  name: 'ClientHomepage',
  computed: {
    user: getUser
  },
  components: {
    MultiImg
  },
  data() {
    const validateTel = (rule, value, callback) => {
      if (!validatePhoneNumber(value)) {
        callback(new Error('请输入正确的联系电话'))
      } else {
        callback()
      }
    }
    return {
      cid: undefined,
      editInfoVisible: false,
      htqdVisible: false,
      editRecordVisible: false,
      cityoptions: getCity(),
      groupoptions: [],
      tagsDrawer: false,
      addVisible: false,
      addLoading: false,
      addDisabled: false,
      addBtnName: '立即提交',
      tempRoute: {},
      loading: false,
      editloading: false,
      wayOption: [],
      tagaoption: [],
      clientinfo: [],
      addForm: {
        way: '',
        labels: [],
        remark: ''
      },
      rulesAdd: {
        way: [{ required: true, message: '请选择跟进方式', trigger: 'change' }],
        remark: [{ required: true, message: '请填写跟进内容', trigger: 'blur' }]
      },
      eForm: {
        realname: '',
        tel: '',
        weixin: '',
        city: [],
        remark: '',
        groupid: null,
        labels: [],
        clientid: 0,
        sex: null,
        shop: '',
        area: null
      },
      eRules: {
        realname: [{ required: true, message: '请输入客户真实姓名', trigger: 'blur' }],
        tel: [{ required: true, trigger: 'blur', validator: validateTel }],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        city: [{ type: 'array', required: true, message: '请选择客户所在地区', trigger: 'blur' }],
        area: [{ pattern: /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/, message: '请输入正确的面积！', trigger: 'blur', required: false }]
      },
      recordForm: {
        recordid: '',
        way: '',
        remark: ''
      },
      rulesRecord: {
        way: [{ required: true, message: '请选择跟进方式', trigger: 'change' }],
        remark: [{ required: true, message: '请填写跟进内容', trigger: 'blur' }]
      },
      contractList: [],
      brandList: [],
      htqdForm: {
        groupId: '',
        clientname: '',
        time: '',
        address: '',
        contractid: null,
        allname: '',
        brand: [],
        imgids: [],
        remark: ''
      },
      groupList: [],
      htqdRules: {
        groupId: [{required: true, message: '请选择展厅负责组织', trigger: 'change'}],
        clientname: [{ required: true, message: '请选择要签订的客户', trigger: 'change' }],
        time: [{ required: true, message: '请选择签订日期', trigger: 'change' }],
        address: [{ required: true, message: '请输入签订地点', trigger: 'blur' }],
        contractid: [{ required: true, message: '请选择签订合同', trigger: 'change' }],
        allname: [{ required: true, message: '请输入客户全称', trigger: 'blur' }],
        brand: [{ required: true, message: '请选择代理品牌，至少一个品牌', trigger: 'change' }],
        imgids: [{ required: true, message: '请上传合同原件图片', trigger: 'change' }]
      }
    }
  },
  created() {
    this.tempRoute = Object.assign({}, this.$route)
    this.cid = this.$route.params && this.$route.params.id
    getClientGroupList({ userid: this.user.dUserid }).then(response => {
      let group = []
      for (let g of response.data) {
        if (g.groupid > 3) {
          group.push({ value: g.groupid, label: g.name })
        }
      }
      this.groupoptions = group
    }).catch(() => {})
    this.getData()
    this.getClientLabel()
    this.getWayAndLabels()
    this.getContractList()
    this.getBrandList()
    this.getGroup()
  },
  methods: {
    getContractList() {
      getContractList({ page: 1, limit: 999999999 }).then(response => {
        this.contractList = response.data
      }).catch(() => {})
    },
    getBrandList() {
      getBrandList().then(response => {
        this.brandList = response.data
      }).catch(() => {})
    },
    getGroup(){
      getGroup().then(response=>{
        this.groupList = response.data
      })
    },
    editInfo() {
      this.editInfoVisible = true
      this.eForm.realname = this.clientinfo.client_name
      this.eForm.tel = this.clientinfo.tel
      this.eForm.weixin = this.clientinfo.weixin
      this.eForm.city = [this.clientinfo.province, this.clientinfo.city, this.clientinfo.county]
      this.eForm.remark = this.clientinfo.remark
      if (this.clientinfo.area === 0) {
        this.eForm.area = null
      } else {
        this.eForm.area = this.clientinfo.area
      }
      this.eForm.shop = this.clientinfo.shop
      if (this.clientinfo.groupid > 3) {
        this.eForm.groupid = this.clientinfo.groupid
      } else {
        this.eForm.groupid = null
      }
      this.eForm.labels = this.addForm.labels
      this.eForm.sex = this.clientinfo.sex + ''
    },
    subEditInfo(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editloading) {
            this.editloading = true
            const data = {
              userid: this.user.dUserid,
              realname: this.eForm.realname,
              tel: this.eForm.tel,
              weixin: this.eForm.weixin,
              province: this.eForm.city[0],
              city: this.eForm.city[1],
              county: this.eForm.city[2],
              remark: this.eForm.remark,
              groupid: this.eForm.groupid,
              labels: this.eForm.labels.join(','),
              clientid: this.cid,
              sex: this.eForm.sex,
              shop: this.eForm.shop,
              area: this.eForm.area
            }
            addClient(data).then(response => {
              this.$message({
                message: '客户信息修改成功',
                type: 'success'
              })
              this.editInfoVisible = false
              this.editloading = false
              this.getData()
            }).catch(() => {
              this.editloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    getWayAndLabels() {
      getWayAndLabels({ userid: this.user.dUserid, clientid: this.cid }).then(response => {
        this.wayOption = response.data.followWays
      }).catch(() => {})
    },
    getClientLabel() {
      getClientLabel({ userid: this.user.dUserid }).then(response => {
        this.tagaoption = response.data
      }).catch(() => {})
    },
    addTags() {
      this.$prompt('请输入标签名称', '添加标签', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '标签名称不可为空'
      }).then(({ value }) => {
        editClientLabel({ userid: this.user.dUserid, type: 0, content: value }).then(response => {
          this.getClientLabel()
        }).catch(() => {})
      }).catch(() => {})
    },
    delTags(tagid) {
      this.$confirm('此操作将永久删除此标签, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        editClientLabel({ type: 2, tagid: tagid }).then(response => {
          this.addForm.labels = []
          this.getClientLabel()
        }).catch(() => {})
      }).catch(() => {})
    },
    submitAddForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.addLoading) {
            this.addLoading = true
            this.addDisabled = true
            this.addBtnName = '提交中...'
            const data = {
              recordid: 0,
              userid: this.user.dUserid,
              clientid: this.clientinfo.client_id,
              remark: this.addForm.remark,
              labels: this.addForm.labels.join(','),
              way: this.addForm.way
            }
            editFollowRecord(data).then(response => {
              this.closeAddForm(formName)
              this.getData()
            }).catch(() => {
              this.addLoading = false
              this.addDisabled = false
              this.addBtnName = '立即提交'
              return false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    closeAddForm(formName) {
      this.$refs[formName].resetFields()
      this.addVisible = false
      this.addLoading = false
      this.addDisabled = false
      this.addBtnName = '立即提交'
    },
    getData() {
      if (this.cid != null && this.cid != undefined && this.cid != '') {
        const data = {
          userid: this.user.dUserid,
          clientid: this.cid
        }
        this.loading = true
        getClientDetail2(data).then(response => {
          this.loading = false
          const pageTitle = `客户主页 - ${response.data.client_name}`
          document.title = pageTitle
          const route = Object.assign({}, this.tempRoute, { title: pageTitle })
          this.$store.dispatch('tagsView/updateVisitedView', route)
          this.clientinfo = response.data
          this.htqdForm.clientname = response.data.client_name
          let lab = []
          for (let tag of this.clientinfo.tagList) {
            lab.push(tag.tagid)
          }
          this.addForm.labels = lab
        }).catch(() => {
          this.loading = false
        })
      } else {
        this.$message.error('获取客户信息失败')
      }
    },
    intoHighSeas() {
      this.$prompt('此操作将不再跟进此客户，请输入原因并确定以继续', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '原因不可为空'
      }).then(({ value }) => {
        intoHighSeas({ clientid: this.cid, userid: this.user.dUserid, remark: value }).then(response => {
          this.$message({
            type: 'success',
            message: '客户已放入公海'
          })
          this.getData()
        }).catch(() => {})
      }).catch(() => {})
    },
    editRecord(rid) {
      for (let r of this.clientinfo.recordList) {
        if (r.record_id === rid) {
          this.recordForm.recordid = r.record_id
          this.recordForm.way = r.way
          this.recordForm.remark = r.content
          break
        }
      }
      this.editRecordVisible = true
    },
    subEditRecord(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.addLoading) {
            this.addLoading = true
            this.addDisabled = true
            const data = {
              recordid: this.recordForm.recordid,
              userid: this.user.dUserid,
              clientid: this.clientinfo.client_id,
              remark: this.recordForm.remark,
              way: this.recordForm.way
            }
            editFollowRecord(data).then(response => {
              this.editRecordVisible = false
              this.addLoading = false
              this.addDisabled = false
              this.getData()
            }).catch(() => {
              this.addLoading = false
              this.addDisabled = false
              return false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    followClient() {
      this.$confirm('此客户将由我来跟进, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        followPublicClient({ clientid: this.cid, userid: this.user.dUserid }).then(response => {
          this.$message({
            type: 'success',
            message: '客户已加入我的客户列表'
          })
          this.getData()
        }).catch(() => {})
      }).catch(() => {})
    },
    openHtqd() {
      this.htqdForm.imgids = []
      this.htqdVisible = true
    },
    subHtqd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editloading) {
            this.editloading = true
            const data = {
              userid: this.user.dUserid,
              clientid: this.clientinfo.client_id,
              time: this.htqdForm.time,
              address: this.htqdForm.address,
              contractid: this.htqdForm.contractid,
              allname: this.htqdForm.allname,
              brandStr: this.htqdForm.brand.join(','),
              imgStr: this.htqdForm.imgids.join(','),
              remark: this.htqdForm.remark,
              exGroup: this.htqdForm.groupId
            }
            signContract(data).then(response => {
              this.$message({
                message: '客户合同签订成功',
                type: 'success'
              })
              this.htqdVisible = false
              this.editloading = false
              this.getData()
            }).catch(() => {
              this.editloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.client-container {
  .client-name{
    letter-spacing: 2px;
    color:#000;
  }
  .client-info-row{
    padding:6px 0;
  }
  .row-line{
    border-bottom: 1px solid #f5f7fa;
    padding-bottom: 14px;
    margin-bottom: 10px;
  }
  .client-sex{
    width: 16px!important;
    height: 16px!important;
    vertical-align: -4px!important;
  }
  .follow-txt{
    font-size: 13px;
  }
  .follow-content{
    color:#999;
    font-size: 13px;
  }
  .follow-editbtn{
    position: absolute;
    right:20px;
    top:40px;
  }
  .tags-container{
    width: 100%;
    position: relative;
    padding: 20px;
    .tags-item{
      position: relative;
      padding: 9px 15px;
      background: #FFF;
      border: 1px dashed #DCDFE6;
      border-radius: 4px;
      display: inline-block;
      color: #606266;
      font-size: 12px;
      font-weight: 500;
      margin:0 20px 20px 0;
      .tags-del{
        padding: 2px!important;
        font-size: 10px!important;
        position: absolute;
        right: -10px;
        top: -6px;
      }
    }
  }
}
</style>
